import VersionStyle, { InterlinearNumberStyle } from "./VersionStyle";
import { WordInterlinearNumberStyle } from "./WordStyle";

export default class WordStyles {

    public static hebrewPartSeparator = 'Â';

    public static copyVersionInterlinearNumberStyle(versionStyle: VersionStyle): WordInterlinearNumberStyle {
        switch (versionStyle.interlinearNumberStyle) {
            case InterlinearNumberStyle.AddStandardSequential:
                return WordInterlinearNumberStyle.AddStandardSequential;
            case InterlinearNumberStyle.AddAlternateSequential:
                return WordInterlinearNumberStyle.AddAlternateSequential;
            default:
                return WordInterlinearNumberStyle.None;
        }
    }
}
